import React, {Component} from 'react';
import './QuemSomos.css';

export default class QuemSomos extends Component {
    render() {
        return (
            <div className="content">
                <h1 className="titulo">Quem Somos</h1>
                <p>ADRF é uma Consultoria Financeira e Estratégica, focada em melhoria de Eficiência de Empresas, formada por Profissionais Experientes do Mercado Financeiro e de Multinacionais que se uniram para prover soluções e dar acesso à Gestão Profissional e sofisticada para Médias e Grandes Empresas.</p>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/QuemSomos.js